export default "__VITE_ASSET__FqG3Bipz__"